/* eslint-disable no-param-reassign, max-params */

const ARTWORK_STATUSES = {
  initial: "initial",
  upload: "upload",
  validate: "validate",
  process: "process",
  complete: "complete"
};

const PROGRESS_RATE = 0.1;
const PROGRESS_CATCHUP_RATE = 1.1;
const PROGRESS_INTERVAL = 100;

const artworkStatusTexts = {
  initial: {
    title: "Upload your design",
    message: "Do not forget to upload your design",
    percentage: {}
  },
  upload: {
    title: "Uploading your artwork...",
    message: "Less than 3 minutes left",
    percentage: { start: 0, end: 35 }
  },
  validate: {
    title: "Validating your artwork...",
    message: "Less than 2 minutes left",
    percentage: { start: 35, end: 50 }
  },
  process: {
    title: "Processing your artwork...",
    message: "Less than 1 minute left",
    percentage: { start: 50, end: 95 }
  },
  complete: {
    title: "",
    message: "Few seconds left",
    percentage: { start: 100, end: 100 }
  }
};

const initialState = {
  uploadArtwork: false,
  uploadArtworkStatus: ARTWORK_STATUSES.initial,
  uploadArtworkProgress: 0.0,
  currentOrder: false,
  fetchProducts: false,
  delivery: false
};

const loadingModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    currentOrder: state => state.currentOrder,
    fetchProducts: state => state.fetchProducts,
    delivery: state => state.delivery,
    uploadArtwork: state => state.uploadArtwork,
    uploadArtworkStatus: state => artworkStatusTexts[state.uploadArtworkStatus],
    uploadArtworkProgress: state => state.uploadArtworkProgress,
    noUpload: state => state.uploadArtworkStatus === ARTWORK_STATUSES.initial,
    isUploadInProgress: state => state.uploadArtworkStatus === ARTWORK_STATUSES.upload,
    isUploadComplete: state =>
      !state.uploadArtwork ||
      [ARTWORK_STATUSES.validate, ARTWORK_STATUSES.process].includes(state.uploadArtworkStatus)
  },

  mutations: {
    setCurrentOrder(state, placement) {
      state.currentOrder = placement;
    },
    setFetchProducts(state, products) {
      state.fetchProducts = products;
    },
    setDelivery(state, products) {
      state.delivery = products;
    },
    setUploadArtworkStatus(state, status) {
      if (!ARTWORK_STATUSES[status]) return;
      state.uploadArtworkStatus = ARTWORK_STATUSES[status];
    },
    setUploadArtwork(state, products) {
      state.uploadArtwork = products;
    }
  },

  actions: {
    incrementUploadArtworkProgress({ state, dispatch }) {
      if (!state.uploadArtwork || state.uploadArtworkProgress >= 100) {
        state.uploadArtwork = false;
        return;
      }

      const { start: lowerLimit, end: upperLimit } =
        artworkStatusTexts[state.uploadArtworkStatus].percentage;

      if (state.uploadArtworkProgress < upperLimit) {
        const progressRate =
          state.uploadArtworkProgress < lowerLimit ? PROGRESS_CATCHUP_RATE : PROGRESS_RATE;
        const remaining = parseFloat((100 - state.uploadArtworkProgress).toFixed(2));

        state.uploadArtworkProgress = parseFloat(
          (state.uploadArtworkProgress + Math.min(progressRate, remaining)).toFixed(2)
        );
      }

      setTimeout(() => {
        dispatch("incrementUploadArtworkProgress");
      }, PROGRESS_INTERVAL);
    }
  }
};

export default loadingModule;
